import { getGridColumns } from "../../../../../serviceBroker/commonApiServiceBroker";
import { getUserId } from "../../../../../utils";
import { TableColumn } from "react-data-table-component";
import { parseISO, isValid } from "date-fns";
import {GridColumnsResponseModel} from "../../../../../models";
import { ColumnsCacheService } from "../utils/columnsCacheService";
function isValidISODate(dateString: string): boolean {
  // Regex to match strict ISO 8601 date format (YYYY-MM-DD) or isostring
  const isoRegex = /^\d{4}-\d{2}-\d{2}(T.*)?$/;

  return isoRegex.test(dateString) && isValid(parseISO(dateString));
}
const parseSelectorValue = (value: any): any => {
  if (typeof value == "boolean") {
    return <input type="checkbox" checked={value} disabled={false} />;
  }
  else if (isValidISODate(value)) {
    //return format(parseISO(value), "dd/MM/yyyy h:mm a");
    const year = value.substring(0, 4);
    const month = value.substring(5, 7);
    const day = value.substring(8, 10);
    const hour = parseInt(value.substring(11, 13), 10);
    const minute = value.substring(14, 16);

    const hour12 = hour % 12 || 12;
    const ampm = hour >= 12 ? 'PM' : 'AM';

    return `${day}/${month}/${year} ${hour12}:${minute} ${ampm}`;
  }
  return value;
};

interface getStaticColumnsProps {
  gridId: number;
  data: any[];
  isArabic: boolean;
  forceRefresh?: boolean;
}

export const getStaticColumns = async ({
  gridId,
  data,
  isArabic,forceRefresh = false,
}: getStaticColumnsProps) => {
  const userId = getUserId();
  const listKeys = Object.keys(data[0]).map((key) => key.toLowerCase());
  // const columnsSettings = await getGridColumns(userId, gridId);
  let columnsSettings: GridColumnsResponseModel[] = [];
  if (!forceRefresh && ColumnsCacheService.hasColumns(userId, gridId)) {
    columnsSettings = ColumnsCacheService.getColumns(userId, gridId);
  } else {
    columnsSettings = await getGridColumns(userId, gridId)??[];
    // Store in cache if we got valid data
    if (columnsSettings) {
      ColumnsCacheService.setColumns(userId, gridId, columnsSettings);
    }
  }

  if (!columnsSettings) {
    return { settingsColumns: [], gridColumns: [] };
  }

  // Process the data (same for both cached and fresh data)
  const gridColumns: TableColumn<any>[] = columnsSettings
      .filter((item) => listKeys.includes(item.Field.toLowerCase()))
      .filter(({ Visable }) => Visable)
      .sort(({ DisplayIndex: a }, { DisplayIndex: b }) => Number(a) - Number(b))
      .map((item) => {
        return {
          name: isArabic ? item.ArabicName : item.EnglishName,
          selector: (row: any) => {
            const fieldKey = Object.keys(row).find(
                (key) => key.toLowerCase() === item.Field.toLowerCase()
            );
            return parseSelectorValue(row[fieldKey || item.Field]);
          },
          sortable: true,
          wrap: true,
          grow: item.Grow || 1,
          width: `${item.Width}%` || "auto",
        };
      });

  const settingsColumns = columnsSettings
      .filter((item) => listKeys.includes(item.Field.toLowerCase()))
      .filter(({ ShowToUser }) => ShowToUser)
      .sort(({ DisplayIndex: a }, { DisplayIndex: b }) => Number(b) - Number(a))
      .sort(({ Visable }) => (Visable ? -1 : 1));

  return { gridColumns, settingsColumns };

  // if (!columnsSettings) return { settingsColumns: [], gridColumns: [] };
  // const gridColumns: TableColumn<any>[] = columnsSettings
  //   .filter((item) => listKeys.includes(item.Field.toLowerCase()))
  //   .filter(({ Visable }) => Visable)
  //   .sort(({ DisplayIndex: a }, { DisplayIndex: b }) => Number(a) - Number(b))
  //   .map((item) => {
  //     return {
  //       name: isArabic ? item.ArabicName : item.EnglishName,
  //       selector: (row: any) => {
  //         const fieldKey = Object.keys(row).find(
  //           (key) => key.toLowerCase() === item.Field.toLowerCase()
  //         );
  //         return parseSelectorValue(row[fieldKey || item.Field]);
  //       },
  //       sortable: true,
  //       wrap: true,
  //       grow: item.Grow || 1,
  //       width: `${item.Width}%` || "auto",
  //     };
  //   });
  // const settingsColumns = columnsSettings
  //   .filter((item) => listKeys.includes(item.Field.toLowerCase()))
  //   .filter(({ ShowToUser }) => ShowToUser)
  //   .sort(({ DisplayIndex: a }, { DisplayIndex: b }) => Number(b) - Number(a))
  //   .sort(({ Visable }) => (Visable ? -1 : 1));
  // return { gridColumns, settingsColumns };
};



